const WIDTHS = [480, 800, 1080];

// Build a WebP srcset from a local cover path (e.g. /insights-covers/foo.jpg ->
// /insights-covers/foo-480.webp 480w, ...). Only the static /insights-covers/ assets
// have these pre-generated variants; generated/re-hosted covers (/api/articles/image/*)
// and remote covers do not, so return null for them and render a plain <img>.
export function coverWebpSrcSet(url) {
  if (!url || !/^\/insights-covers\//i.test(url)) return null;
  const base = url.replace(/\.(jpe?g|png|webp)$/i, '');
  return WIDTHS.map((w) => `${base}-${w}.webp ${w}w`).join(', ');
}

export function CoverImage({ url, alt, sizes, eager = false, width, height, className }) {
  if (!url) return null;
  const srcSet = coverWebpSrcSet(url);
  const priority = eager ? { fetchPriority: 'high' } : { loading: 'lazy' };
  const img = (
    <img
      src={url}
      alt={alt}
      width={width}
      height={height}
      className={className}
      decoding="async"
      {...priority}
    />
  );
  if (!srcSet) return img;
  return (
    <picture>
      <source type="image/webp" srcSet={srcSet} sizes={sizes} />
      {img}
    </picture>
  );
}
